export const createDynamicField = (initialData = {}) => ({
    _cleared: false,
    _isNew: true,
    uniqueId: `${Date.now()}_${Math.random()}`,
    ...initialData,
});

export const createClearedField = (initialData = {}) => ({
    _cleared: true,
    _isNew: false,
    uniqueId: `${Date.now()}_${Math.random()}`,
    ...initialData,
});

export const hasValidField = (fields, requiredKeys) => {
    if (!requiredKeys || requiredKeys.length === 0) return false;
    return fields.some((field) =>
        requiredKeys.every((key) => {
            const value = field[key];
            if (typeof value === "number") return Number(value) > 0;
            if (Array.isArray(value)) return value.length > 0;
            return !!value;
        }),
    );
};

export const getDisabledOptions = (fields, currentIndex, keyToCheck) =>
    fields
        .map((f, i) => (i !== currentIndex && f[keyToCheck] ? f[keyToCheck] : null))
        .filter((value) => value !== null && value !== "");

export const convertFieldsToFormValues = (fields, fieldName, keyMappings) => {
    const validFields = fields
        .filter((field) =>
            keyMappings.every(({ key }) => {
                const value = field[key];
                if (typeof value === "number") return Number(value) > 0;
                if (Array.isArray(value)) return value.length > 0;
                return !!value;
            }),
        )
        .map((field) => {
            const result = {};
            keyMappings.forEach(({ key, transform }) => {
                let value = field[key];
                if (transform) value = transform(value);
                result[key] = value;
            });
            return result;
        });
    return { [fieldName]: validFields };
};

export const createInitialDynamicFields = (values, keyName, initialData = {}) => {
    const existingFields = values?.[keyName];
    if (existingFields && existingFields.length > 0) {
        return existingFields.map((item, index) => ({
            _cleared: false,
            _isNew: false,
            uniqueId: `${Date.now()}_${index}`,
            ...initialData,
            ...Object.keys(item).reduce((acc, key) => {
                acc[key] = item[key]?.value ?? item[key];
                return acc;
            }, {}),
        }));
    }
    return [createDynamicField(initialData)];
};
